import c, { AES as crypto } from 'crypto-js';

// Encryption key for cookie set/get.
// this is meant to be slightly annoying to decipher once uglified,
// but is NOT meant to be the end-all for user security. The API must do that.
export default function encr() {
  // USED IN ENCRYPTION FUNCTION
  // inside app.js - meant to be slightly annoyingly elusive
  // but is not a replacement for API security
  let a = 378799200000; // eslint-disable-line no-unused-vars
  let n = 5; // eslint-disable-line no-unused-vars

  return eval('a + n + "pb2016"'); // eslint-disable-line no-eval
}

export function decr(cookieData) {
  if (!cookieData || cookieData === 'undefined') return;
  try {
    return JSON.parse(cookieData);
  } catch (e) {
    return JSON.parse(crypto.decrypt(cookieData, encr()).toString(c.enc.Utf8));
  }
}



// WEBPACK FOOTER //
// ./js/util/encr.js